import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
// import { withStyles } from '@mui/material';
import { AppBar } from 'react-admin'
// import BackButton from './backButton'
import { List, ListButton, TopToolbar, Pagination,  Create, SimpleForm, TextInput, email, BooleanField,Link, Button, SelectInput, Datagrid, TextField, ReferenceField, EditButton, DeleteButton, ShowButton, DateField } from 'react-admin';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditActions = ({ permissions, basePath, data, resource }) => (
    <TopToolbar>
        <ListButton basePath="sap_contracts_product_list" />
    </TopToolbar>
)

const ProductVaue = ({ record }) => {
    let recordValue = record && record.product_status && record.product_status[1] ? 'ON' : 'OFF';
    return recordValue;
}


export const ProductChangeLogList = ({ permissions, ...props }) => {
    console.log('ProductChangeLogList===================')
    return (
        <Scrollbars class="scroll-container">
            {/* <BackButton/> */}
            <List title="User logs" sort={{ field: 'updated_at', order: 'DESC' }} actions={<EditActions/>}  {...props}   bulkActionButtons={false}  >
                <Datagrid>
                    <TextField source="updated_by" sortable={false} />
                    <DateField label="Updated date" source="updated_at" showTime />
                    <TextField label="Material Name" source="material_description" />
                    <TextField source="plant_name" label="Plant Name"  sortable={false}/>
                    <ProductVaue source="setting_value[1]" label="Value" sortable={false} />
                    {/* <TextField source="email" />
                    <StatusField source="status" />
                    <TextField source="userRole" /> */}
                </Datagrid>
            </List>
        </Scrollbars>
    )
}

